import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IBillingBalance, IBillingDocument } from '@dch/billing-business-logic';
import { EnvironmentService, TranslationService } from '@dch/ng-common';
import {
  DEFERRAL_LANDING,
  DEFERRAL_SUCCESSFUL_NEW_DATE_PAGE,
} from '../../config/my-bill.constants';
import { OnDestroyHookDirective } from '../../common/hooks';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs/operators';
import { ApplicationState } from 'src/app/state/reducers';
import { selectCustomerAccount } from 'src/app/state/selectors/customer-account.selector';
import { getDeferralCardVariant } from '../../services/utils.service';

@Component({
  selector: 'my-bill-deferral-card',
  templateUrl: './my-bill-deferral-card.component.html',
  standalone: false,
})
export class MyBillDeferralCardComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly selectedCustomerAccount$ = this.store.select(selectCustomerAccount);

  @Input() customerPaymentProfile: IBillingBalance['customerPaymentProfile'];
  @Input() partialDeferralCheck: IBillingDocument['partialDeferralCheck'];
  @Input() dueDate: string;
  @Input() deferralDate?: string;
  @Input() documentReference: string;
  @Input() billingAccountNumber: string;
  isSmoothAccess: boolean;
  isStaySignedIn: boolean;

  redirectLink: string;
  variantDisplayed?: '1' | '2' | '3' | '4';
  title = '';
  text = '';
  showModal = false;

  get isVisible(): boolean {
    return this.variantDisplayed !== '4';
  }

  get isDisabled(): boolean {
    return this.variantDisplayed === '3';
  }

  constructor(
    private translationService: TranslationService,
    private router: Router,
    private store: Store<ApplicationState>,
    private environmentService: EnvironmentService
  ) {
    super();
  }

  ngOnInit() {
    this.isSmoothAccess = this.environmentService.isSmoothAccess;
    this.getSelectedCustomerAccountStaySignedInStatus();
    this.variantDisplayed = getDeferralCardVariant(
      this.customerPaymentProfile,
      this.partialDeferralCheck
    );
    this.initTitleAndText();
  }

  onClick() {
    if (this.variantDisplayed === '1') {
      this.redirectLink = DEFERRAL_LANDING;
    } else if (this.variantDisplayed === '2') {
      this.redirectLink = DEFERRAL_SUCCESSFUL_NEW_DATE_PAGE;
    }
    this.navigateToScreen();
  }

  onCancel() {
    this.showModal = false;
  }

  private navigateToScreen() {
    if (this.isSmoothAccess || this.isStaySignedIn) {
      this.showModal = true;
    } else {
      this.router.navigate([this.redirectLink]);
    }
  }

  private initTitleAndText() {
    if (this.variantDisplayed === '1' || this.variantDisplayed === '3') {
      this.title = this.translationService.getTranslatedValueFor(
        'bills.deferral.deferralCard.variant1.title'
      );
      this.text = this.translationService.getTranslatedValueFor(
        'bills.deferral.deferralCard.variant1.text'
      );
    } else if (this.variantDisplayed === '2') {
      this.title = this.translationService.getTranslatedValueFor(
        'bills.deferral.deferralCard.variant2.title'
      );

      this.text = `${this.translationService.getTranslatedValueFor(
        'bills.deferral.deferralCard.variant2.beforeDueDateText'
      )} ${this.dueDate} ${this.translationService.getTranslatedValueFor(
        'bills.deferral.deferralCard.variant2.afterDueDateText'
      )} ${this.deferralDate}`;
    }
  }

  private getSelectedCustomerAccountStaySignedInStatus() {
    this.addSubscription(
      this.selectedCustomerAccount$
        .pipe(
          filter(
            (selectedCustomerAccount) => selectedCustomerAccount !== undefined
          ),
          tap((selectedCustomerAccount) => {
            this.isStaySignedIn = Boolean(selectedCustomerAccount.staySignedIn);
          })
        )
        .subscribe()
    );
  }
}
